import { call, put, takeEvery } from 'redux-saga/effects';
import { getDashboardStatsApi, getMonthlyScanStatsApi, getLicenseUsageApi } from '../../api/dashboardApi/dashboardApi';
import {
  GET_DASHBOARD_STATS_REQUEST,
  GET_DASHBOARD_STATS_SUCCESS,
  GET_DASHBOARD_STATS_FAILURE,
  GET_MONTHLY_SCAN_STATS_REQUEST,
  GET_MONTHLY_SCAN_STATS_SUCCESS,
  GET_MONTHLY_SCAN_STATS_FAILURE,
  GET_LICENSE_USAGE_REQUEST,
  GET_LICENSE_USAGE_SUCCESS,
  GET_LICENSE_USAGE_FAILURE
} from '../../constants/dashboardConstant/dashboardConstants';

function* getDashboardStatsSaga(action) {
  try {
    const { itSalesId, oemId } = action.payload;
    const response = yield call(getDashboardStatsApi, itSalesId, oemId);
    yield put({ type: GET_DASHBOARD_STATS_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: GET_DASHBOARD_STATS_FAILURE, payload: error.message });
  }
}

function* getMonthlyScanStatsSaga(action) {
  try {
    const oemId = action.payload;
    const response = yield call(getMonthlyScanStatsApi, oemId);
    yield put({ type: GET_MONTHLY_SCAN_STATS_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: GET_MONTHLY_SCAN_STATS_FAILURE, payload: error.message });
  }
}

function* getLicenseUsageSaga(action) {
  try {
    const { itSalesId, licenseId } = action.payload;
    const response = yield call(getLicenseUsageApi, itSalesId, licenseId);
    yield put({ type: GET_LICENSE_USAGE_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: GET_LICENSE_USAGE_FAILURE, payload: error.message });
  }
}

export default function* dashboardSaga() {
  yield takeEvery(GET_DASHBOARD_STATS_REQUEST, getDashboardStatsSaga);
  yield takeEvery(GET_MONTHLY_SCAN_STATS_REQUEST, getMonthlyScanStatsSaga);
  yield takeEvery(GET_LICENSE_USAGE_REQUEST, getLicenseUsageSaga);
}